module.exports = __webpack_public_path__ + "static/media/plaza-5.609a3aee.webp";